import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { installPreviewTransport } from './utils/founderPreview';
import { initSentry, Sentry } from './sentry';
import SentryErrorFallback from './components/SentryErrorFallback';

// Initialize Sentry as early as possible (dormant if DSN not configured).
initSentry();
installPreviewTransport();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={SentryErrorFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

